module.exports = __webpack_public_path__ + "static/media/SetupCheck.ec4a200b.svg";